import { abrirPreferenciasDeCookies } from '../lib/consentimento';

/**
 * Política de Privacidade.
 *
 * O banner de cookies aponta para cá, e a LGPD pede que a pessoa saiba o que é
 * coletado antes de consentir. O texto descreve o que o site de fato guarda —
 * conferido no banco e no código —, não um modelo genérico. Mudou o que se
 * coleta, muda aqui e a data de atualização.
 *
 * Os dados do responsável foram informados pelo cliente. O texto ainda merece
 * uma leitura de quem cuida da parte jurídica da loja.
 */
const ATUALIZADA_EM = '14 de setembro de 2026';

/** Controlador dos dados, como exige o art. 9º da LGPD. */
const RESPONSAVEL = {
  razaoSocial: 'DMS SKINS LTDA',
  cnpj: '68.954.342/0001-84',
  email: 'dani.m.serras@gmail.com',
};

export function PrivacidadePage() {
  return (
    <article className="panel privacidade">
      <h1>Política de Privacidade</h1>
      <p className="dim">Última atualização: {ATUALIZADA_EM}</p>

      <p>
        Esta política explica quais dados a DMS SKINS coleta quando você usa o site, para que eles servem e como você
        pode exercer os seus direitos previstos na Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
      </p>

      <h2>Quem é o responsável pelos seus dados</h2>
      <p>
        <b>{RESPONSAVEL.razaoSocial}</b>, CNPJ {RESPONSAVEL.cnpj}. Contato para assuntos de privacidade e dados
        pessoais: <a href={`mailto:${RESPONSAVEL.email}`}>{RESPONSAVEL.email}</a>.
      </p>

      <h2>1. Dados que coletamos</h2>
      <ul>
        <li>
          <b>Conta Steam:</b> ao entrar com a Steam recebemos o seu SteamID e o perfil público (apelido, foto e
          endereço do perfil). Não recebemos nem guardamos a sua senha. Guardamos o histórico de apelidos para
          confirmar a identidade de quem negocia.
        </li>
        <li>
          <b>Cadastro:</b> o seu trade link da Steam e, se você informar, o seu WhatsApp.
        </li>
        <li>
          <b>Pedidos:</b> as skins escolhidas, valores, status, observações e o histórico de cada pedido, de compra,
          venda de inventário ou upgrade.
        </li>
        <li>
          <b>Atendimento e avaliações:</b> as mensagens que você envia pelo atendimento do site e os feedbacks que
          publica.
        </li>
        <li>
          <b>Segurança da sessão:</b> endereço IP e navegador usados no login.
        </li>
        <li>
          <b>Navegação (com o seu consentimento):</b> páginas visitadas e ações no site, medidas pelo Google Analytics
          com identificadores anônimos.
        </li>
      </ul>

      <h2>2. Para que usamos</h2>
      <ul>
        <li>Identificar você e manter a sua conta e o seu login.</li>
        <li>Executar os pedidos: comprar as skins, enviar a proposta de troca e falar com você pelo WhatsApp.</li>
        <li>Prevenir fraude, como a troca de apelido depois de informar o trade link.</li>
        <li>Responder às suas dúvidas e publicar as avaliações que você enviou.</li>
        <li>Com o seu consentimento: entender como o site é usado e medir o resultado de anúncios.</li>
      </ul>

      <h2>3. Cookies</h2>
      <p>O site usa três tipos de cookies e armazenamento local do navegador:</p>
      <ul>
        <li>
          <b>Necessários:</b> mantêm o login, a sacola e as suas preferências (idioma, moeda e a própria escolha de
          cookies). Sem eles o site não funciona, por isso ficam sempre ativos.
        </li>
        <li>
          <b>Analíticos:</b> Google Analytics, para medir audiência. Só são usados se você permitir.
        </li>
        <li>
          <b>Marketing:</b> Google Ads e Meta (Facebook), para anúncios personalizados. Só são usados se você
          permitir.
        </li>
      </ul>
      <p>
        Você pode mudar a sua escolha a qualquer momento:{' '}
        <button type="button" className="cookies-link inline" onClick={abrirPreferenciasDeCookies}>
          abrir as preferências de cookies
        </button>
        .
      </p>

      <h2>4. Com quem compartilhamos</h2>
      <ul>
        <li>
          <b>Valve/Steam:</b> para o login e para as propostas de troca, que acontecem na própria Steam.
        </li>
        <li>
          <b>Google:</b> Google Analytics e Google Ads, conforme o seu consentimento.
        </li>
        <li>
          <b>Meta:</b> anúncios, conforme o seu consentimento.
        </li>
        <li>
          <b>Fornecedores de infraestrutura:</b> hospedagem do site e do banco de dados, que processam os dados em
          nosso nome.
        </li>
      </ul>
      <p>Não vendemos os seus dados.</p>

      <h2>5. Por quanto tempo guardamos</h2>
      <p>
        Os dados da conta e dos pedidos ficam guardados enquanto a conta existir e pelo prazo necessário para cumprir
        obrigações legais e resolver eventuais disputas. Os dados de navegação do Google Analytics são mantidos por até
        14 meses.
      </p>

      <h2>6. Os seus direitos</h2>
      <p>
        Você pode pedir a confirmação de que tratamos os seus dados, o acesso a eles, a correção, a anonimização ou a
        exclusão do que não for obrigatório manter, a portabilidade, informações sobre compartilhamento e a revogação do
        consentimento. Para isso, escreva para <a href={`mailto:${RESPONSAVEL.email}`}>{RESPONSAVEL.email}</a> ou fale
        com a gente pelo atendimento do site ou pelo WhatsApp informado no rodapé.
      </p>

      <h2>7. Mudanças nesta política</h2>
      <p>
        Quando esta política mudar, a data no topo desta página é atualizada. Mudanças importantes são avisadas no
        site.
      </p>
    </article>
  );
}
